"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _components = require("../../../components");

var _hooks = require("../../../hooks");

var _ModifierItemModule = _interopRequireDefault(require("./ModifierItem.module.scss"));

var _visuallyHidden = require("@react-aria/visually-hidden");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ModiifierItem = function ModiifierItem(_ref) {
  var cellType = _ref.cellType,
      name = _ref.name,
      price = _ref.price,
      isNested = _ref.isNested,
      quantity = _ref.quantity,
      multiSelect = _ref.multiSelect,
      onClick = _ref.onClick,
      className = _ref.className,
      increment = _ref.increment,
      decrement = _ref.decrement;

  var _useTemplate$useCell = _hooks.useTemplate.useCell(cellType),
      buttons = _useTemplate$useCell.buttons,
      labelTextStyles = _useTemplate$useCell.labelTextStyles,
      views = _useTemplate$useCell.views;

  return /*#__PURE__*/_react["default"].createElement(_components.View, {
    type: views.background,
    Component: "li",
    className: "".concat(_ModifierItemModule["default"]["modifierItem"], " ").concat(className),
    dataTest: name,
    hoverable: true
  }, /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: !quantity
  }, /*#__PURE__*/_react["default"].createElement("div", {
    tabIndex: "-1",
    role: "button",
    className: _ModifierItemModule["default"]["modifierItem-overlay"],
    onClick: onClick,
    onKeyDown: onClick
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _ModifierItemModule["default"]["modifierItem-content--name"]
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.primary
  }, name)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _ModifierItemModule["default"]["modifierItem-content--price"]
  }, /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: price
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.secondary,
    className: _ModifierItemModule["default"]["modifierItem-content--price-value"]
  }, price)), /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: !isNested
  }, /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: multiSelect
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _ModifierItemModule["default"]["modifierItem-selectors"]
  }, /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: quantity !== 0
  }, /*#__PURE__*/_react["default"].createElement(_components.ThemeButton, {
    type: buttons.primary,
    className: _ModifierItemModule["default"]["modifierItem-btn"],
    onClick: decrement
  }, "-")), /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: quantity !== 0
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    "aria-live": "polite",
    type: labelTextStyles.tertiary
  }, /*#__PURE__*/_react["default"].createElement(_visuallyHidden.VisuallyHidden, null, name, " Quantity: "), quantity)), /*#__PURE__*/_react["default"].createElement(_components.ThemeButton, {
    type: buttons.primary,
    className: _ModifierItemModule["default"]["modifierItem-btn"],
    onClick: increment
  }, "+"))), /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: !multiSelect
  }, /*#__PURE__*/_react["default"].createElement(_components.Condition.False, null, /*#__PURE__*/_react["default"].createElement(_components.Radio, {
    type: buttons.primary,
    className: _ModifierItemModule["default"]["modifierItem-btn"],
    value: quantity,
    onChange: onClick
  }))))), /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: isNested
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _ModifierItemModule["default"]["modifierItem-nestedSelector"]
  }, ">")));
};

var _default = /*#__PURE__*/_react["default"].memo(ModiifierItem);

exports["default"] = _default;